// This service handles local storage operations

const STORAGE_KEY = "dogNutritionPreferences"

export function savePreferences(preferences) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences))
    return true
  } catch (error) {
    console.error("Error saving preferences to localStorage:", error)
    return false
  }
}

export function getPreferences() {
  try {
    const preferences = localStorage.getItem(STORAGE_KEY)
    return preferences ? JSON.parse(preferences) : null
  } catch (error) {
    console.error("Error retrieving preferences from localStorage:", error)
    return null
  }
}

export function clearPreferences() {
  try {
    localStorage.removeItem(STORAGE_KEY)
    return true
  } catch (error) {
    console.error("Error clearing preferences from localStorage:", error)
    return false
  }
}

